/* global angular */

import './style.less';

export default () => {
  return ($scope, $q, $stateParams, $state, $uibModalInstance, ProfileClass, ApiClass) => {
    'ngInject';

    const { profile } = ProfileClass.profileComplete;
    const profile_uid = $stateParams.id || profile.profile_uid;

    $scope.close = () => $uibModalInstance.dismiss('cancel');

    $scope.createActivity = () => {
      $scope.close();
      $state.go('app.author.activities', $stateParams);
    };

    $scope.add = () => {
      const activities = $scope.activities.filter(({ selected }) => selected);
      $uibModalInstance.close(activities);
    };

    ApiClass.activitiesGet(
      { profile_uid: profile_uid, manage: true },
      {},
      {
        queryParams: {
          filters: JSON.stringify({
            basic: true
          }),
          includes: JSON.stringify({
            profiles: false,
            progress: false
          })
        }
      }
    ).then(({ data: { items: activities } }) => {
      $scope.activities = angular.copy(activities).filter(({ active, archive }) => active && !archive);
      $scope.loaded = true;
    });
  };
};



// WEBPACK FOOTER //
// ./src/app/modals/addActivity/index.js